var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    rx: 4,
    fill: "#51CDA0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5845 14.1543C23.545 14.0639 23.4897 13.9812 23.4212 13.9102L18.4212 8.91018C18.3502 8.84167 18.2675 8.78636 18.177 8.74685C18.152 8.73518 18.1254 8.72852 18.0987 8.71935C18.029 8.69562 17.9564 8.68133 17.8829 8.67685C17.8654 8.67518 17.8495 8.66602 17.832 8.66602H11.9987C11.0795 8.66602 10.332 9.41352 10.332 10.3327V23.666C10.332 24.5852 11.0795 25.3327 11.9987 25.3327H21.9987C22.9179 25.3327 23.6654 24.5852 23.6654 23.666V14.4993C23.6654 14.4818 23.6562 14.466 23.6545 14.4477C23.6505 14.3741 23.6362 14.3015 23.612 14.2318C23.6037 14.2052 23.5962 14.1793 23.5845 14.1543ZM20.8204 13.666H18.6654V11.511L20.8204 13.666ZM11.9987 23.666V10.3327H16.9987V14.4993C16.9987 14.7204 17.0865 14.9323 17.2428 15.0886C17.3991 15.2449 17.611 15.3327 17.832 15.3327H21.9987L22.0004 23.666H11.9987Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.668 16.9993H20.3346V18.666H13.668V16.9993ZM13.668 20.3327H20.3346V21.9993H13.668V20.3327ZM13.668 13.666H15.3346V15.3327H13.668V13.666Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/fileIcon.4664dadf9ff5e48c133e659c7d25b44c.svg";
export { ForwardRef as ReactComponent };